var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",class:{
    'wrapper-dark-theme': _vm.isTwitchUser,
    'wrapper--mobile-bottom-nav': _vm.showMobileBottomNav,
  }},[_c('side-bar',{key:_vm.sidebarRenderKey,attrs:{"nav-links":_vm.visibleSidebarLinks}}),_c('div',{staticClass:"main-panel",class:{
      'main-panel-dark-theme': _vm.isTwitchUser,
      'main-panel--create-clips-detail': _vm.isCreateClipsDetail,
    }},[_c('dashboard-content',{class:{ 'content--create-clips-detail': _vm.isCreateClipsDetail },nativeOn:{"click":function($event){return _vm.toggleSidebar.apply(null, arguments)}}})],1),(_vm.showMobileBottomNav)?_c('mobile-bottom-nav'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }